<template>
  <section class="section">
    <p class="desc" :class="{ clamped: !expanded }">
      <span v-html="t('download.appDataContent')"></span>
      <span class="toggle" @click="expanded = !expanded">
        {{ expanded ? t('common.less') : t('common.more') }}
      </span>
    </p>

    <div class="dev-card">
      <div class="dev-icon">
        <van-icon name="user-o" size="20" color="#6b7280" />
      </div>
      <div class="dev-info">
        <p class="dev-name">{{ t('donwload.appName') }}</p>
        <p class="dev-role">{{ t('appStore.developerRole') }}</p>
      </div>
      <van-icon name="arrow" size="16" color="#9ca3af" />
    </div>
  </section>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const expanded = ref(false);
</script>

<style scoped>
.section {
  padding: 20px 16px 0;
}

.desc {
  margin: 0;
  font-size: 14px;
  line-height: 1.45;
  color: #1f2937;
}

.desc.clamped {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.toggle {
  color: #007AFF;
  margin-left: 4px;
}

.dev-card {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
  padding: 12px;
  border-radius: 12px;
  background: #f3f4f6;
}

.dev-icon {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dev-info {
  flex: 1;
  min-width: 0;
}

.dev-name {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}

.dev-role {
  margin: 2px 0 0;
  font-size: 13px;
  color: #6b7280;
}
</style>
